import React from 'react';
import { Window, WindowActionsBar, WindowMoveEvent } from '@progress/kendo-react-dialogs';

interface FeedbackFormModalProps {
    label: string
    url: string
}

const FeedbackFormModal: React.FC<FeedbackFormModalProps> = ({ url, label }) => {
    const [isVisible, setIsVisible] = React.useState(false);

    const onClose = () => {
        setIsVisible(false);
        return false;
    }

    return (
        <>
            <label role="button" className="nav-link" onClick={() => setIsVisible(true)}><u>{label}</u></label>
            {isVisible && <Window width={750} height={780} title="" onClose={onClose} modal={true} minimizeButton={() => null}
                maximizeButton={() => null}>
                <iframe src={url} width="700px" height="700px" style={{ border: 'none' }}></iframe>
            </Window>
            }
        </>
    );
};

export default FeedbackFormModal;